import { Button, Content, Section } from "../../AppStyle";
import pbLogo from "../../assets/images/p_b_logo.png";
import { ImageLogo, ImageLogoMobile, Message } from "./AboutStyle";

const About = () => {
  return (
    <Section id="about" color="#FFFFFF">
      <Content style={{ justifyContent: "center", alignItems: "center" }}>
        <ImageLogoMobile src={pbLogo} alt="logo" />
        <Message className="message">
          <h4 style={{ fontWeight: 500 }}>
            P&B Custom Designs is your destination for all of your cabinet and
            custom furniture needs.
          </h4>
          <h5 style={{ marginBottom: 10 }}>
            We have been involved in the cabinet and furniture building industry
            for over 10 years.
          </h5>
          <Button className="responsive-btn" href="#contact">
            CONTACT US
          </Button>
        </Message>
        <ImageLogo src={pbLogo} alt="logo" />
      </Content>
    </Section>
  );
};

export default About;
